// The time zone menu's helpers (TimeZoneMenu.vue): every zone grouped by region, where the menu
// goes on screen, and the keys that move within it. Added 2026-10-14.

const GAP = 4;
const MARGIN = 8;
const MENU_MIN_WIDTH = 220;
const MENU_MIN_HEIGHT = 240;
const MOVES = {ArrowDown: 1, ArrowUp: -1};

// "America/Los_Angeles" → "America/Los Angeles"
export function getLabel(zone) {
  return zone.replaceAll("_", " ");
}

// within its region: "America/Argentina/Buenos_Aires" → "Argentina / Buenos Aires"
export function getCityLabel(zone) {
  const parts = getLabel(zone).split("/");
  return parts.length > 1 ? parts.slice(1).join(" / ") : parts[0];
}

export function getRegionName(zone) {
  return zone.split("/")[0];
}

// [{name: "Africa", zones: ["Africa/Abidjan", …]}, …]; no "Etc/GMT+5" or region-less "UTC"
export function getRegions(zones) {
  const regions = new Map();
  for (const zone of zones) {
    if (!zone.includes("/") || zone.startsWith("Etc/")) continue;
    const name = getRegionName(zone);
    regions.set(name, [...(regions.get(name) || []), zone]);
  }
  return [...regions].map(([name, regionZones]) => ({name, zones: regionZones}));
}

// the fixed menu's containing block: the Profile <dialog> (it has a transform), else the window
export function getOrigin(element) {
  const dialog = element?.closest("dialog");
  return dialog?.getBoundingClientRect() || {left: 0, top: 0, bottom: window.innerHeight};
}

// under the button, else (too little room there) above it; never past the window's right edge
export function getMenuPosition(buttonRect, origin) {
  const menuWidth = Math.max(buttonRect.width, MENU_MIN_WIDTH);
  const rightmost = window.innerWidth - MARGIN - menuWidth;
  const left = `${Math.max(MARGIN, Math.min(buttonRect.left, rightmost)) - origin.left}px`;
  const width = `${menuWidth}px`;
  const below = window.innerHeight - buttonRect.bottom - GAP - MARGIN;
  if (below >= MENU_MIN_HEIGHT) {
    return {left, width, top: `${buttonRect.bottom + GAP - origin.top}px`, maxHeight: `${below}px`};
  }
  const bottom = `${origin.bottom - buttonRect.top + GAP}px`;
  return {left, width, bottom, maxHeight: `${buttonRect.top - GAP - MARGIN}px`};
}

// a typed letter: the next item starting with it
function getTypeaheadTarget(letter, items, index) {
  const order = [...items.slice(index + 1), ...items.slice(0, index + 1)];
  const match = order.find((item) => item.textContent.trim().toLowerCase().startsWith(letter));
  return match ? items.indexOf(match) : -1;
}

// the index of the item a key moves focus to; -1: the key doesn't move it
export function getKeyTarget(key, items, index) {
  if (key in MOVES) return (index + MOVES[key] + items.length) % items.length;
  if (key === "Home") return 0;
  if (key === "End") return items.length - 1;
  if (key.length !== 1 || !/\S/.test(key)) return -1;
  return getTypeaheadTarget(key.toLowerCase(), items, index);
}
